<template>
  <div class="empty-img">
    <img
      :src="emptyImgUrl"
      :style="{ width: imgWidth }"
      alt=""
    />
    <span class="">暂无数据</span>
  </div>
</template>

<script>
import { getMoguoCdnUrl } from "../../utils/assets";
export default {
  props: {
    imgWidth: {
      type: String,
      default: "200px",
    },
  },
  computed: {
    emptyImgUrl() {
      return getMoguoCdnUrl("/cdn/static/images/empty.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-img {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  height: 300px;

  img {
    width: 200px;
  }

  span {
    color: var(--el-text-color-placeholder);
    margin-top: 10px;
    font-size: 14px;
  }
}
</style>
